
import { ArrowLeft, Home } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

export const RegisterHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate(-1)}
            className="p-2 hover:bg-muted rounded-full transition-colors"
            aria-label="Go back"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
          <Link
            to="/"
            className="p-2 hover:bg-muted rounded-full transition-colors flex items-center gap-1"
            aria-label="Go to home page"
          >
            <Home className="h-5 w-5" />
            <span className="text-sm">Home</span>
          </Link>
        </div>
        <Link
          to="/signin"
          className="text-sm text-muted-foreground hover:text-primary transition-colors"
        >
          Already have an account? Sign in
        </Link>
      </div>
      <div className="flex flex-col space-y-2 text-center">
        <h1 className="text-2xl font-semibold tracking-tight">Create an account</h1>
        <p className="text-sm text-muted-foreground">
          Enter your details below to create your account
        </p>
      </div>
    </div>
  );
};
